var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EditTagsModalV2',{ref:"editTagsModal",attrs:{"tags":_vm.lensTags,"header":'Edit Lens Tags',"count-text":"creative"},on:{"deleteTag":_vm.deleteTag,"editTag":_vm.editTag,"createTag":_vm.createTag,"close":function($event){return _vm.$emit('close')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }